<app-component-button-header-back href="/account/options/persons">
    {{ 'HEADERS.TO_USERS' | translate }}
</app-component-button-header-back>

<div class="list-group" *ngIf="allMembers else loadingg" style="float:left; overflow: auto; height: 700px">
    <h2>{{ 'USER_PROFILE.TEXT.USERS' | translate }}</h2>
    <div (click)="changeUser(member)"
         *ngFor="let member of allMembers"
         [class.blocked_user]="member.project_setting.observation_type === 'blocked'"
         [class.inactive_user]="!member.is_active"
         [class.selected-person]="profile && (member.guid === profile.guid)"
         class="list-group-item list-group-item-action"
         style="display: flex; margin-bottom: 1px"
    >
        <img *ngIf="member.project_setting.is_project_admin"
             alt="#"
             ngbTooltip="{{ 'USERS_PROFILE.ROLE.ADMIN' | translate }}"
             src="../../../../assets/images/admin.svg">
        <span class="pointer">{{ helper.fullName(member) }}</span>
    </div>
</div>


<div *ngIf="profile && !loading else loadingg" class="content p-4" style="max-width: 80%">
    <div class="flex-display align-items-center"
         style="width: fit-content; background-color: white; border: 3px solid #3c779a; border-radius: 30px"
    >
        <div data-action="openProfile" style="display: flex;
                                      align-items: center;
                                      flex-direction: column;
                                      border-right: 1px solid lightgray"
        >
            <div class="avatar m-2">
                @if (currentUserGuid === profile.guid) {
                    <app-avatar
                            [profile]="profile"
                            [size]="'full'"
                            [detailProfile]="true"
                    ></app-avatar>
                }
            </div>
            <app-component-button-more (answer)="updateProjectAdmin($event)" [bold]="true"
                                       [hidden]="true"
                                       [variables]="signs"
                                       class="m-2 project_rights_setter"
                                       style="cursor: pointer"
            >
    <span *ngIf="profile.project_setting.observation_type !== 'blocked'">
        <i class="{{profile.project_setting && profile.project_setting.is_project_admin ?
            'icon-down-1 text-danger' : 'icon-up-1 text-success'}}"></i>
    </span>
                <span *ngIf="profile.project_setting.observation_type === 'blocked'">
        <i class="bi bi-x-lg text-danger"></i>
    </span>
                {{ 'USER_PROFILE.ROLE.' + profile.project_setting.observation_type | translate }}
            </app-component-button-more>
        </div>
        <div class="ms-3 p-4">
            <h1>
                {{ helper.fullName(profile) }}
                <i (click)="modalService.openTemplateModal(editNameModal)"
                   *ngIf="requestMember.guid === profile.guid"
                   class="bi bi-pen pointer"
                ></i>
            </h1>
            <span>
        <b>{{ 'USER_PROFILE.TEXT.POSITION' | translate }}: </b>
        <app-component-input-inline
                (emitSave)="editMemberPosition($event)"
                *ngIf="requestMember.project_setting.is_project_admin"
                [value]="profile.project_setting.position ?? '-'"
                editByPen="true"
        ></app-component-input-inline>
        <ng-container *ngIf="!requestMember.project_setting.is_project_admin">
            {{ profile.project_setting.position ?? '-' }}
        </ng-container>
    </span><br>
            <span>
        <app-component-input-inline
                *ngIf="requestMember.guid === profile.guid"
                [value]="profile.email"
                editByPen="true"></app-component-input-inline>
        <ng-container *ngIf="requestMember.guid !== profile.guid">
            {{ profile.email }}
        </ng-container>
    </span><br>
            <span>
        <b>{{ 'USER_PROFILE.TEXT.PHONE' | translate }}: </b>
        <app-component-input-inline
                (emitSave)="editProfile(null, $event)"
                *ngIf="requestMember.guid === profile.guid"
                [value]="profile.phone ?? '-'"
                editByPen="true"
        ></app-component-input-inline>
        <ng-container *ngIf="requestMember.guid !== profile.guid">
            {{ profile.phone ?? '-' }}
        </ng-container>
    </span>
            <br> <br>
            <span>
        <small>{{ 'USER_PROFILE.TEXT.LAST_ACTIVE' | translate }}</small>
        <br>
        <b>{{ profile.project_setting.last_request | date:'HH:mm dd.MM.yyyy' }}</b>
    </span>

            <i *ngIf="profile.has_crypto"
               class="bi bi-key"
            ></i>
        </div>
    </div>

    <div class="task__footer order-3" style="margin-top: 20px">
        <div class="super__tabs" style="margin-bottom: -15px">
            <div (click)="tab = 'profile'; docTab = 'all'"
                 [class.active]="tab === 'profile'"
                 class="super__tabs tab tab_plane"
                 data-action="profile"
            >
                <span>{{ 'USER_PROFILE.TEXT.PROFILE' | translate }}</span>
            </div>
            <div (click)="tab = 'tasks'; docTab = 'all'"
                 [class.active]="tab === 'tasks'"
                 class="super__tabs tab tab_plane"
                 data-action="tasks"
            >
                <span>{{ 'USER_PROFILE.TEXT.TASKS' | translate }}</span>
            </div>
            <div (click)="tab = 'documents'; docTab = 'all'"
                 [class.active]="tab === 'documents'"
                 class="super__tabs tab tab_plane"
                 data-action="documents"
            >
                <span>{{ 'USER_PROFILE.TEXT.DOCS' | translate }}</span>
            </div>
            <div (click)="tab = 'contracts'; docTab = 'all'"
                 [class.active]="tab === 'contracts'"
                 class="super__tabs tab tab_plane"
                 data-action="contracts"
            >
                <span>{{ 'USER_PROFILE.TEXT.CONTRACT' | translate }}</span>
            </div>
        </div>
        <div class="tab__content">
            <ng-container *ngIf="tab === 'profile'">
                <ng-container *ngTemplateOutlet="profileStructure">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="tab === 'tasks'">
                <ng-container *ngTemplateOutlet="tasks">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="tab === 'documents'">
                <ng-container *ngTemplateOutlet="documents">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="tab === 'contracts'">
                <ng-container *ngTemplateOutlet="contracts">
                </ng-container>
            </ng-container>
        </div>
    </div>

    <ng-template #profileStructure>
        <div class="card">
            <div class="card-header">
                {{ 'USER_PROFILE.TEXT.STRUCTURE_TITLE' | translate }}
                <i (click)="redirectToDepartmentsSettings()"
                   *ngIf="requestMember.project_setting.is_project_admin"
                   class="bi bi-gear-fill pointer"
                   ngbTooltip="{{ 'USER_PROFILE.BUTTONS.STRUCTURE_SETTINGS' | translate }}"
                ></i>
            </div>

            <div *ngIf="!departmentAccordions.length" class="alert alert-info">
                <small><i>{{ 'EMPTY_LISTS.STRUCTURE' | translate }}</i></small>
            </div>

            <div class="card-body">
                <app-accordion
                        [accordionData]="{
                    allHeaders: departmentAccordions,
                    templateAccordionBody: containerTemplate
                }"
                ></app-accordion>
            </div>
        </div>

        <ng-template #containerTemplate let-data="data">
            <div *ngIf="data else loadingg" class="dash-list" style="margin-bottom: unset">
                <div class="card flex justify-content-center division-container">
                    <div *ngIf="!data.divisions.length">
                        <small><i>{{ 'EMPTY_LISTS.MEMBER_DIVISIONS' | translate }}</i></small>
                    </div>
                    <div *ngFor="let divisionItem of data.divisions" class="division-item">
                        <ng-container
                                *ngTemplateOutlet="division; context: {divisionItem: divisionItem}"></ng-container>
                    </div>
                </div>

                <ng-template #division let-divisionItem="divisionItem">
                    <div>
                        <div class="division-item item-head flex-display justify-content-between">
                            <div>
                                <i (click)="divisionSlider[divisionItem.id] = !divisionSlider[divisionItem.id]"
                                   *ngIf="divisionItem.subdivision && divisionItem.subdivision.length"
                                   [class]="divisionSlider[divisionItem.id] ? 'bi bi-caret-down me-5px pointer' :
                                        'bi bi-caret-right me-5px pointer'"
                                ></i>
                                <i class="bi-people me-1"
                                   ngbTooltip="{{ 'USER_PROFILE.TEXT.DIVISION' | translate }}"
                                ></i>
                                <span>{{ divisionItem.name }}</span>
                            </div>
                        </div>

                        <div *ngIf="divisionSlider[divisionItem.id]">
                            <div *ngFor="let divisionItem of divisionItem.subdivision" class="subdivision">
                                <ng-container
                                        *ngTemplateOutlet="division; context: {divisionItem: divisionItem}"></ng-container>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </ng-template>
    </ng-template>

    <ng-template #tasks>
        <div class="card">
            <div class="card-header">
                {{ 'USER_PROFILE.TEXT.BP_TITLE' | translate }}
                <i (click)="redirectToBoardsSettings()"
                   *ngIf="requestMember.project_setting.is_project_admin"
                   class="bi bi-gear-fill pointer"
                   ngbTooltip="{{ 'USER_PROFILE.BUTTONS.BP_SETTINGS' | translate }}"
                ></i>
            </div>
            <app-boards-accordion [profile]="profile"></app-boards-accordion>
        </div>
    </ng-template>

    <ng-template #documents>
        <ul class="nav nav-pills nav-fill nav-tabs" style="background: #F5F5F5;">
            <li class="nav-item">
                <a (click)="docTab = 'all'"
                   [class.active]="docTab === 'all'"
                   class="nav-link"
                   data-action="all"><b>{{ 'USER_PROFILE.TEXT.DOC_TAB.ALL' | translate }}</b></a>
            </li>
            <li class="nav-item">
                <a (click)="docTab = 'sign'; docPagination.filter = 'inbox'; onEventFind(docPagination);"
                   [class.active]="docTab === 'sign'"
                   class="nav-link"
                   data-action="sign">
                    <b>{{ 'USER_PROFILE.TEXT.DOC_TAB.SIGN' | translate }}</b>
                </a>
            </li>
            <li class="nav-item">
                <a (click)="docTab = 'approve'; docPagination.filter = 'approve'; onEventFind(docPagination);"
                   [class.active]="docTab === 'approve'"
                   class="nav-link"
                   data-action="approve">
                    <b>{{ 'USER_PROFILE.TEXT.DOC_TAB.VISA' | translate }}</b>
                </a>
            </li>
            <li class="nav-item">
                <a (click)="docTab = 'archive'; docPagination.filter = 'signed'; onEventFind(docPagination);"
                   [class.active]="docTab === 'archive'"
                   aria-disabled="true"
                   class="nav-link disabled"
                   data-action="archive">
                    <b>{{ 'USER_PROFILE.TEXT.DOC_TAB.ARCHIVE' | translate }}</b>
                </a>
            </li>
        </ul>

        <div class="tab__content">
            <ng-container *ngIf="docTab === 'sign'">
                <ng-container *ngTemplateOutlet="sign">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="docTab === 'approve'">
                <ng-container *ngTemplateOutlet="approve">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="docTab === 'all'">
                <ng-container *ngTemplateOutlet="all">
                </ng-container>
            </ng-container>
            <ng-container *ngIf="docTab === 'archive'">
                <ng-container *ngTemplateOutlet="archive">
                </ng-container>
            </ng-container>
        </div>


        <ng-template #sign>
            <app-component-folder-and-file-table
                    (eventClick)="onEventTrClick($event, docModal)"
                    (eventFind)="onEventFind($event)"
                    [$mediator]="controller.$mediator"
                    [preparedPagination]="docPagination"
            ></app-component-folder-and-file-table>
        </ng-template>

        <ng-template #approve>
            <app-component-folder-and-file-table
                    (eventClick)="onEventTrClick($event, docModal)"
                    (eventFind)="onEventFind($event)"
                    [$mediator]="controller.$mediator"
                    [preparedPagination]="docPagination"
            ></app-component-folder-and-file-table>
        </ng-template>

        <ng-template #all>
            <app-documents-repo-structure
                    [profile]="profile"
            ></app-documents-repo-structure>
        </ng-template>

        <ng-template #archive>
            <app-component-folder-and-file-table
                    (eventClick)="onEventTrClick($event, docModal)"
                    (eventFind)="onEventFind($event)"
                    [$mediator]="controller.$mediator"
                    [preparedPagination]="docPagination"
            ></app-component-folder-and-file-table>
        </ng-template>
    </ng-template>

    <ng-template #contracts>
        <app-contracts-table
                [currentProject]="profile.project_setting.project.guid"
                [filter]="'my'"
                [isInProfile]="true"
                [isNavigate]="true"
                [profile]="profile"
        >
            <!--      Добавить переход на контракт      -->
        </app-contracts-table>
    </ng-template>
</div>


<ng-template #docModal let-modal>
    <app-button-modal-close [modalSize]="'xl'" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div class="d-inline-block w-100">
            <app-component-doc-view (deleteEmit)="modal.close()"
                                    [fileUkey]="selectedFile.key"
                                    [isOpenModal]="true"
            ></app-component-doc-view>
        </div>
    </div>
</ng-template>

<ng-template #editNameModal let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>{{ 'MODALS.FIELDS.FIRSTNAME' | translate }}</h2>
        <input #newName value="{{profile.firstname}}">
        <h2>{{ 'MODALS.FIELDS.LASTNAME' | translate }}</h2>
        <input #newLastname value="{{profile.lastname}}">
        <h2>{{ 'MODALS.FIELDS.MIDDLENAME' | translate }}</h2>
        <input #newMiddlename value="{{profile.middlename}}">

        <button (click)="editProfile(modal, null, newName.value, newLastname.value, newMiddlename.value)"
                class="btn btn-success"
        >
            {{ 'MODALS.BUTTONS.SAVE' | translate }}
        </button>
    </div>
</ng-template>

<ng-template #loadingg>
    <app-component-loading></app-component-loading>
</ng-template>

<ng-container *ngIf="loading">
    <app-component-loading></app-component-loading>
</ng-container>
